import styles from "./Screen.module.css";
import React, { useRef, useState, useEffect } from "react";
import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { setCurrentModule, saveStateBeforeNavigation } from "../../store/reducers/progressionReducer";
import { logEvent } from "../../analytics";

export default function Module({ module, src, dispatch, analytics, isNew }) {
  const moduleToString = {
    eventRequestForm: "New Service Available",
    patientData: "Patient Door Access",
    patientSelection: "Patient Selection",
    newService: "Innovation 2026",
    toriCalculator: "Toric Calculator",
    optimizedSelection: "Optimized Selection",
  };

  const svgRef = useRef();
  const gsapTween = useRef();
  const { contextSafe } = useGSAP();

  // Gérer l'état "nouveau" pour le module newService
  const [hasBeenClicked, setHasBeenClicked] = useState(false);

  useEffect(() => {
    if (isNew && module === "newService") {
      const clicked = localStorage.getItem("newService_clicked");
      setHasBeenClicked(clicked === "true");
    }
  }, [isNew, module]);

  const hoverEffect = contextSafe((event) => {
    const element = event.currentTarget;
    const rect = element.getBoundingClientRect();

    const relativeX = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    const relativeY = ((event.clientY - rect.top) / rect.height) * 2 - 1;

    const maxRotation = 20; // Ajustez cette valeur pour une rotation plus ou moins forte
    const rotationX = relativeY * maxRotation; // Rotation autour de l'axe X
    const rotationY = -relativeX * maxRotation; // Rotation autour de l'axe Y
    gsapTween.current?.kill();
    gsapTween.current = gsap.to(svgRef.current, {
      rotationX: rotationX / 2,
      rotationY: -rotationY,
      duration: 0.1,
      ease: "power2.out",
    });
  });

  const hoverOut = contextSafe(() => {
    gsapTween.current?.kill();
    gsapTween.current = gsap.to(svgRef.current, {
      rotationX: 0,
      rotationY: 0,
      duration: 1,
      ease: "power2.out",
    });
  });

  const handleClick = () => {
    if (analytics) {
      logEvent("Module", "click", analytics);
    }

    // Marquer comme cliqué si c'est le module newService
    if (isNew && module === "newService") {
      localStorage.setItem("newService_clicked", "true");
      setHasBeenClicked(true);
    }

    if (src) {
      // Vérifier si c'est une URL interne (commence par / ou # ou contient new-product)
      const isInternalLink = src.startsWith("/") || src.includes("new-product") || src.startsWith("#");
      
      if (isInternalLink) {
        // Navigation interne : sauvegarder l'état et naviguer dans le même onglet
        dispatch(saveStateBeforeNavigation());
        
        // Utiliser window.location.hash pour naviguer (compatible avec HashRouter)
        if (src.startsWith("#")) {
          window.location.hash = src;
        } else if (src.startsWith("/")) {
          window.location.hash = "#" + src;
        } else {
          window.location.hash = "#/" + src;
        }
      } else {
        // Lien externe : ouvrir dans un nouvel onglet
        window.open(src, "_blank");
      }
    } else {
      dispatch(setCurrentModule(module)); // Si pas de lien, dispatcher le module
    }
  };

  return (
    <div
      className={`${styles.module} ${isNew && !hasBeenClicked ? styles.newModule : ''}`}
      onClick={handleClick} // Utiliser la nouvelle fonction handleClick

    >

      <div
        className={`${styles.container} ${isNew && !hasBeenClicked ? styles.newContainer : ''}`}
        ref={svgRef}
        onPointerMove={hoverEffect}
        onPointerLeave={hoverOut}
      >
        <svg
          preserveAspectRatio={"none"}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.outer}
        >
          <circle cx="50%" cy="50%" r="50%" stroke="#ADD2D4" />
        </svg>
        <svg
          preserveAspectRatio={"none"}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.inner}
        >
          <circle cx="50%" cy="50%" r="50%" stroke="#ADD2D4" />
        </svg>
        <img src={`/screen/${module}.svg`} alt="" />
      </div>
      <p className={isNew && !hasBeenClicked ? styles.newLabel : ''}>{moduleToString[module]}</p>
      {["optimizedSelection"].includes(module) && <div className={styles.comingsoon}>Coming Soon</div>}

    </div >
  );
}
